<template>
<v-container>
      <v-row>
         <v-col cols='8'><h1>Informations de la carte SIM</h1></v-col>
         <v-col cols='4' class="text-right">
           <v-btn to="/souscription/offresmobile/portabilite">Retour</v-btn>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <br/>
      <v-col cols="12">
          <v-card >
            <div id="qr-code-full-region"></div>
          </v-card>
      </v-col>
  <div>
    <v-row justify="center">
      <v-col cols="8" >
        <v-form>
        <v-text-field                     
            label="Carte SIM"
          v-model="simCode"
          name="simCode"
          
          append-outer-icon="mdi-barcode-scan"
          type="number"  
          required
          clearable
          :error-messages="simCodeErrors"
          :counter="11"
          @input="$v.simCode.$touch()"
          @blur="$v.simCode.$touch()"
          @click:append-outer="loadOrCloseScan()"
        ></v-text-field>
        </v-form>
      </v-col>
    
    

    <!--<v-col cols="8" sm="5" md="5" lg="5">
        <v-btn v-on:click="createScanChoice()"  outlined block class="rechercher">Select cam</v-btn>
      </v-col>-->
    </v-row>

   
     <v-row>
          <v-col cols='12' class="text-right"><v-btn class="poursuivre" :loading="loading" @click="valideSim()">Poursuivre</v-btn></v-col>
        </v-row>
  </div>
</v-container>
</template>

<script>
import { Html5Qrcode } from "html5-qrcode";
import { Html5QrcodeScanner } from "html5-qrcode";
import { required, minLength,maxLength } from 'vuelidate/lib/validators'
import { PortabiliteService } from "../../providers/PortabiliteService";
const portabiliteService = new PortabiliteService();
export default {
  data() {
    return {
      message: [],
      Html5QrcodeScanner: null,
      simCode : null,
      scanLoad: false,
      loading:false
    };
  },
  validations: {
    simCode: {required, minLength: minLength(11),maxLength: maxLength(11) }
  },
  computed: {
    simCodeErrors () {
      const errors = []
      if (!this.$v.simCode.$dirty) return errors
      !this.$v.simCode.maxLength && errors.push('Numero à 11 chiffres')
      !this.$v.simCode.minLength && errors.push('Numero à 11 chiffres')      
      !this.$v.simCode.required && errors.push('Numéro obligatoire.')
      return errors
    }
  },
  methods: {
    init(){
       var sessionSouscription = this.$globalService.getSessionSouscription();
        if(sessionSouscription != null && sessionSouscription.simCode )
          this.simCode = sessionSouscription.simCode;
      
    },
    valideSim: function(){
     
      this.$v.$touch();
   
      if (this.$v.$invalid ){  
         this.$dialog.warning({
          text: "Veuillez vérifier votre saisie",
          title: "Attention",
          persistent: false,
          actions: {
            false: "Fermer",
          },
        });
        return;
      } else {
        this.loading = true;
      portabiliteService.simValidate(this.simCode,this.$root.user.domaine,this.$root.user.site).then((res) => {
           this.loading = false;
          
          if (res) {
            if (res.err != "error") {
              const sessionSouscription = this.$globalService.setSessionSouscription('simCode',this.simCode);
              if(sessionSouscription == null || !sessionSouscription.simCode){
                this.$dialog.error({
                  text: "Une erreur s'est produite",
                  title: 'Erreur',
                  persistent: false,
                  actions: {
                    false: 'Fermer'
                  }
                })
                return;
              }else
                this.$router.push({ name: "RecapMobile" });
            }else{
              this.$dialog.error({
                text: res.err_msg,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
            
            }
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$dialog.notify.error(this.$root.errorMessage, {
            position: "bottom-right",
            timeout: 5000,
          });
          return error;
        });
      }
    },
    creatScan() {
      /*const config = { fps: 10, qrbox: 250 };
      const html5QrcodeScanner = new Html5QrcodeScanner(
        "qr-code-full-region",
        config
      );
      html5QrcodeScanner.render(this.onScanSuccess);*/
      this.simCode='';
      try {
      this.Html5QrcodeScanner = new Html5Qrcode( "qr-code-full-region");
                const config = { fps: 500, qrbox: { width: 250, height: 250 }};
                config['formatsToSupport'] = ['CODE_128'];
               /* const qrCodeSuccessCallback = (decodedText, decodedResult) => {
                    alert("Votre code html5QrCode :\n"+decodedText);
                    
                    html5QrCode.stop()
                };*/

                this.Html5QrcodeScanner.start({ facingMode: "environment" }, config, this.onScanSuccess);
               
                this.scanLoad = true;
      } catch (error) {
        this.$dialog.error({
                  text: error.message,
                  title: 'Erreur',
                  persistent: false,
                  actions: {
                    false: 'Fermer'
                  }
                })
      }
    },
    createScanChoice(){
      const config = { fps: 10, qrbox: { width: 250, height: 250 }};
        var html5QrcodeScannerChoice = new Html5QrcodeScanner(
                    "qr-code-full-region", config);
                html5QrcodeScannerChoice.render(this.onScanSuccess);
    },
    onScanSuccess(decodedText, decodedResult) {
      const obj = { decodedResult: decodedResult };
      this.message.push(obj);
      this.simCode = decodedText;
      //alert("Votre code :\n"+decodedText);

      

        this.$dialog.notify.info('Code carte SIM: '+decodedText, {
        position: 'bottom',
        timeout: 5000
      });
                    
        this.Html5QrcodeScanner.stop()
        this.scanLoad = false;
    },

    loadOrCloseScan(){
      if(this.scanLoad){
        if(this.Html5QrcodeScanner){
          this.Html5QrcodeScanner.stop();
          this.scanLoad = false;
        }
      }else
        this.creatScan();
    }
  },
   mounted() {
    this.init();
  },
};
</script>